export const BomTypeMaterial = 'Material';
export const BomTypeSalesOrder = 'SalesOrder';
export const BomTypeProductionOrder = 'ProductionOrder';

export const MaxNumberOfBomLevels = 7;
